import { useEffect } from 'react'


const QRSelfieFan = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' /> */}
               

                 {/* Atributos vitales para fondos: 
                  autoPlay: inicia solo
                  loop: se repite infinitamente
                  muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                  playsInline: previene que en iOS el video se abra a pantalla completa
                */}
                
                {/* {isActiveWomensMode ? (
                    // <video 
                    //     src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    //     className='SelfieFan__Screen__QR__Background__Video' 
                    //     autoPlay loop muted playsInline 
                    // />
                    <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )} */}

                <img src="/img/page/backgrounds/background.png" className="Screen__Thanks__Background__Image" alt="" />
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'> {/* Container-FullHeight */}
                <div className='SelfieFan__Screen__QR__Container'>
                    {isActiveWomensMode ? (
                        <div className='SelfieFan__Screen__QR__Container__Instructions' style={{ backgroundColor: 'rgba(255,255,255,0.85)' }}>
                            <img src="/img/page/xolos-five-black.png" className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo" />
                            <p className='SelfieFan__Screen__QR__Container__Instructions__Text Text--Gradient--Womens'>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                        </div>
                    ) : isActiveWomensMode === false && (
                        <div className='SelfieFan__Screen__QR__Container__Instructions'>
                            <img src="/img/page/xolos-five.png" className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo" />
                            <p className='SelfieFan__Screen__QR__Container__Instructions__Text'>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                        </div>
                    )}
                    
                    <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
                </div>
            </div>

            {isActiveWomensMode ? (
                <footer className='SelfieFan__Screen__QR__Footer FooterCredits' style={{ color: '#000000', backgroundColor: 'rgba(255,255,255,0.85)', padding: '0 16px', borderRadius: '16px' }}>Hecho con ♥ por Interaktia | 2026</footer>
            ) : isActiveWomensMode === false && (
                <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
            )}
        </>
    )
}

export { QRSelfieFan };